import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from 'react';

import { 
    createStripeCheckoutSessionAndRedirect, 
    getStripePortalSessionAndRedirect 
} from "api/stripe";
import { checkUserSubscription } from "api/stripe";
import { doesUserHaveCustomerId } from "api/firebase/stripe";

interface BillingPlanProps {
    user: any,
}

export default function BillingPlan({ user }: BillingPlanProps) {
    const [activeSubscription, setActiveSubscription] = useState<boolean>(false);
    const [customerId, setCustomerId] = useState<string | null>(null);

    const handleActivatePlan = async () => {
         await createStripeCheckoutSessionAndRedirect();
    };

    const handleManagePlan = async () => {
        await getStripePortalSessionAndRedirect({ customerId });
    }

    useEffect(() => {
        const checkIfUserHasCustomerId = async () => {
            const { customerId }  = await doesUserHaveCustomerId(user);
            const { doesUserHaveActiveSubscription } = await checkUserSubscription({ customerId });
            setCustomerId(customerId);
            setActiveSubscription(doesUserHaveActiveSubscription && !!customerId);
        }
        if (user) checkIfUserHasCustomerId();
    }, [user])

    // add spinner for that brief second
    return (
        <Container>
            <PlanContainer>
                { activeSubscription ?
                <>
                    <Typography variant="h6">Monthly Plan</Typography>
                    <Typography>$2.99 / month</Typography>
                </> 
                : 
                    <Typography variant="h6">No active plan</Typography> 
                }
            </PlanContainer>
            <ButtonContainer>
                { activeSubscription ?
                    <Button onClick={handleManagePlan} variant="contained">Manage Plan</Button>
                :
                    <Button onClick={handleActivatePlan} variant="contained">Activate Plan</Button> 
                }
            </ButtonContainer>
        </Container>
    )
}

const Container = styled(Box)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
});

const PlanContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
});

const ButtonContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    alignItems: "center",
});
